import React from "react"
import { ReactComponent as IconBigArrow } from "../../../../../../../../Common/Assets/big-arrow.svg"
import { ReactComponent as YodaHappy } from "../../../../../../../../Common/Assets/yoda-happy.svg"

export const TutorialContentEmpty = () => (
    <div className="mt-16 px-38">
        <IconBigArrow />
        <div className="px-32">
            <YodaHappy className="w-48 h-48 mx-auto" />
            <p className="text-xl text-center text-rhino-800 font-semibold mt-6">
                Ready for your
                <br />
                content, I am
            </p>
        </div>
    </div>
)
